<template>
  <v-dialog v-model="showDeleteProfileDialog" persistent max-width="450">
    <v-card class="mt-0 mb-0">
      <v-card-title class="subtitle-1">
        {{ lang.general.areYouSure }}
      </v-card-title>

      <v-card-text>
        <p class="subtitle-2">
          {{ lang.general.byDelete }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeDeleteProfileDialog()"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn small class="ml-2 btn-bg" elevation="0" @click="deleteProfile()">
          {{ lang.actions.delete }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteProfileDialog",
  props: {
    showDeleteProfileDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDeleteProfileDialog() {
      this.$emit("closeDeleteProfileDialog");
    },
    deleteProfile() {
      this.$emit("deleteProfile");
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>
